import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { TransactionActorType } from '@frontend/transaction/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ID = 'transaction-actor-type-select';

export const TRANSACTION_ACTOR_TYPE_SELECT_OPTIONS = [
    {
        value: TransactionActorType.DROPPED_OFF_BY,
        label: TransactionActorType.DROPPED_OFF_BY,
        display: CommonMessage.OBJECTS.TRANSACTION.DROPPED_OFF_BY
    },
    {
        value: TransactionActorType.PICKED_UP_BY,
        label: TransactionActorType.PICKED_UP_BY,
        display: CommonMessage.OBJECTS.TRANSACTION.PICKED_UP_BY
    },
    {
        value: TransactionActorType.INITIATED_BY,
        label: TransactionActorType.INITIATED_BY,
        display: (
            <FormattedMessage
                id='Objects.TRANSACTION.INITIATED_BY'
                description='Label for the transaction user type initiated by'
                defaultMessage='Initiated by'
            />
        )
    }
];

export interface TransactionActorTypeSelectProps extends Omit<SelectInputV2Props<TransactionActorType>, 'options' | 'onSelect'> {
    onSelect?: (value: TransactionActorType | null) => void;
}

export const TransactionActorTypeSelect = (props: TransactionActorTypeSelectProps) => {
    const { onSelect, ...rest } = props;

    return (
        <SelectInputV2<TransactionActorType>
            {...rest}
            id={props.id || ID}
            options={TRANSACTION_ACTOR_TYPE_SELECT_OPTIONS}
            disableSearch={props.disableSearch ?? true}
            onSelect={(option) => onSelect?.(option ? (option.value as TransactionActorType) : null)}
        />
    );
};
